<template>
  <Layout :linksData="linksData">
    <v-container class="my-4 w-100">
      <!-- <v-row no-gutters>
        <v-col cols="6" class="pa-0 mb-4">
          <span class="d-flex align-center ga-2">
            <Input
              class="w-100"
              v-model="search"
              type="search"
              :icon="SearchIcon"
              :placeholder="$t('search_here') + '...'"
              @keyup="delayedHandleInput"
            />
          </span>
        </v-col>
      </v-row> -->
      <v-row no-gutters>
        <LeadInfo />
        <Activities />
        <UpdatesComp />
        <AttachementComp />
      </v-row>
    </v-container>
  </Layout>
</template>

<script>
import Layout from "@/components/crm/layouts/Layout.vue";
import Input from "@/components/crm/assets/Input.vue";
import SearchIcon from "@/assets/images/icons/search.svg";
// import AdvancedFilter from "@/components/crm/leads/advancedFilter.vue";
import { useLeadsStore } from "@/store/crm/useLeadsStore";
import snapchatIcon from "@/assets/images/icons/snapcaht.svg";
import xIcon from "@/assets/images/icons/x.svg";
import instagramIcon from "@/assets/images/icons/instagram.svg";
import facebookIcon from "@/assets/images/icons/facebook.svg";
import tiktokIcon from "@/assets/images/icons/tiktok.svg";
import phoneIcon from "@/assets/images/icons/phone.svg";
import LinkedInIcon from "@/assets/images/icons/linkedIn.svg";

import LeadInfo from "@/components/crm/leads/SingleLeadCom/LeadInfo.vue";
import Activities from "@/components/crm/leads/SingleLeadCom/Activities.vue";
import UpdatesComp from "@/components/crm/leads/SingleLeadCom/UpdatesComp.vue";
import AttachementComp from "@/components/crm/leads/SingleLeadCom/AttachementComp.vue";
export default {
  components: {
    Layout,
    Input,
    SearchIcon,
    // AdvancedFilter,
    LeadInfo,
    Activities,
    UpdatesComp,
    AttachementComp,
  },
  data() {
    return {
      snapchatIcon,
      xIcon,
      instagramIcon,
      facebookIcon,
      tiktokIcon,
      phoneIcon,
      LinkedInIcon,
      linksData: [
        { name: "home", link: "/home-page" },
        { name: "leads", link: "/leads-management" },
        { name: "Lead Details", link: "" },
      ],
      store: useLeadsStore(),
      lead: [],
    };
  },
  methods: {
    // delayedHandleInput() {
    //   clearTimeout(this.typingTimer);
    //   this.typingTimer = setTimeout(() => {
    //     this.handleInput();
    //   }, 1000);
    // },
    // handleInput() {
    //   this.store.search = this.search;
    //   this.store.getAllLeads();
    //   this.store.getALead();

    // },
  },
};
</script>

<style scoped></style>
